import React from "react";

function NotFound() {
  return <h1>404 - Seite nicht gefunden</h1>;
}

export default NotFound;
